import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const drmDeleteCustomColumn = async ([
  body,
]) => { 
  const response = await axios.delete(
    `${URLS.DRM_CUSTOM_COLUMN_DELETE}/${body?.viewCodes}/${body?.version}/${body?.userCode}`
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
